const rmSpaces = (st: string | undefined): string | undefined =>
	st ? st.replace(/\s+/g, "") : undefined
export default rmSpaces
